import React, { useEffect, useState } from 'react';
const WORDS = ['hot flashes', 'brain fog', 'sleep disruption', 'mood swings', 'low energy'];
export function RotatingWord() {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(current => (current + 1) % WORDS.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);
  return <span className="relative inline-grid grid-cols-1 grid-rows-1 text-orla-sienna font-display italic border-b-[3px] border-orla-saffron pb-1" data-id="element-289">
      {WORDS.map((word, i) => <span key={word} className={`col-start-1 row-start-1 transition-opacity duration-150 ease-in-out ${i === index ? 'opacity-100' : 'opacity-0'}`} aria-hidden={i !== index} data-id="element-290">
          {word}
        </span>)}
    </span>;
}